import CategoryPageRenderer from "@/components/CategoryPageRenderer";
export default function PerlengkapanIbadah() {
  return <CategoryPageRenderer pageKey="perlengkapan-ibadah" />;
}
